import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

export default function SearchInput({ value, onChange, placeholder, className = 'relative flex-1 min-w-[220px] max-w-xs' }) {
  return (
    <div className={className}>
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full bg-white border border-border-lines rounded-lg pl-10 pr-3 py-2.5 text-sm outline-none"
        placeholder={placeholder}
      />
      <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-3" size={16} />
    </div>
  )
}
